import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { TriangleAlert } from "lucide-react";
import { ReplyWarningDialogProps } from ".";
import { Button } from "@/components/ui/button";
import { QuestionWithDependents } from "@/features/question/hooks/useQuery/useGetQuestionsBySurveyId";

export function ReplyWarningDialog({ open, onOpenChange, questionsThatWillBeInvalidated, onSubmit }:ReplyWarningDialogProps) {
    
    return (
        <Dialog open={open} onOpenChange={onOpenChange} defaultOpen={false} modal={true}>
            <DialogContent >
                <DialogHeader className="gap-3">
                    <DialogTitle>
                        <div className="flex items-center gap-2">
                            <TriangleAlert size="24" className="text-orange-500" />
                            Are you sure?
                        </div>
                    </DialogTitle>

                    <DialogDescription>
                        The response you provided for the parent question does not meet the conditions required to enable the related question(s).
                    </DialogDescription>
                </DialogHeader>

                <div className="">
                    <div className="flex items-center gap-2">
                        <TriangleAlert size="24" className="text-orange-500" />
                        <p className='text-sm font-semibold text-muted-foreground'>As a result, following history will be deleted:</p>
                    </div>
                    {questionsThatWillBeInvalidated.map((question) => question.dependent_questions).flat().map((question) => (
                        <QuestionToInvalidate key={question.id} question={question} />
                    ))}
                </div>

                <DialogFooter className="flex items-center justify-center">
                    <Button type="button" variant="secondary" onClick={()=>onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button type="button" onClick={() => {
                        onOpenChange(false);
                        onSubmit();
                    }}>
                        Submit
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

function QuestionToInvalidate({ question }: { question: QuestionWithDependents }) {
    return (
        <div className="text-sm">
            <span className="">{question.question}</span>
            <div className="ml-2 pl-2 mt-1 border-l-[1px] border-gray-300">
                {question.dependent_questions.map((dependentQuestion) => (
                    <QuestionToInvalidate key={dependentQuestion.id} question={dependentQuestion} />
                ))}
            </div>
        </div>
    );
}